// Small inline brand marks so we don't rely on external logo assets.
export const AppleMark = ({ className = "" }) => (
  <svg viewBox="0 0 384 512" className={className} fill="currentColor" aria-hidden="true">
    <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" />
  </svg>
);

export const PlayStoreMark = ({ className = "" }) => (
  <svg viewBox="0 0 512 512" className={className} aria-hidden="true">
    <path fill="#00d1ff" d="M47 27.7C41 34 37.5 43.7 37.5 56.3v399.4c0 12.6 3.5 22.3 9.9 28.6l1.4 1.2L272 262.9v-13.8L48.3 26.5z" />
    <path fill="#ffd800" d="M346.6 337.8 272 262.9v-13.8l74.7-74.8 1.7 1L437 226c25.4 14.4 25.4 38 0 52.5z" />
    <path fill="#ff3d44" d="M347.7 336.7 272 261 47 486c8.4 8.9 22.2 10 37.8 1.1z" />
    <path fill="#00e676" d="M347.7 175.3 84.8 24.9C69.2 16 55.4 17.1 47 26l225 225z" />
  </svg>
);

export const LotusMark = ({ className = "" }) => (
  <svg viewBox="0 0 48 40" className={className} fill="none" aria-hidden="true">
    <path d="M24 6c3 6 4 12 0 22-4-10-3-16 0-22Z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
    <path d="M24 28C16 24 10 16 9 8c8 1 13 8 15 20Z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
    <path d="M24 28c8-4 14-12 15-20-8 1-13 8-15 20Z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
    <path d="M4 26c6 8 34 8 40 0" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
  </svg>
);
